import React, { useState, useEffect } from 'react';
import Loading from './Loading';
import Home from './Home';

const Component1 = () => {
  return <Loading />;
};

const Component2 = () => {
  return <Home />;
};

const Tran = () => {
  const [showComponent1, setShowComponent1] = useState(true);

  useEffect(() => {
    // After 3 seconds, hide Component 1 and show Component 2
    const timeoutId = setTimeout(() => {
      setShowComponent1(false);
    }, 3000);

    // Clear the timeout to prevent memory leaks when the component is unmounted
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div>
   <Component2 />
    </div>
  );
};

export default Tran;
